import React from 'react'
import { LazyImage } from 'components/image';
import { services } from 'utils/constant/siteIntro/landingPage'

function Index() {
    return (
        <div className="bg-[#f6f6f6] flex items-center justify-center h-fit md:min-h-screen">
            <div className="w-full max-w-[95%] mx-auto">
                <div className="flex flex-col items-center text-black">
                    <div className='text-3xl sm:text-[40px] text-center my-5'>Premium Services Set to <br /> World-Class Standards</div>
                    <div className="grid grid-cols-1 gap-5 m-4 mb-3 sm:grid-cols-1 md:grid-cols-3 md:my-10 md:m-0">
                        {services?.map((item) => (
                            <div class="bg-white rounded-xl p-4 flex flex-col items-start w-[340px]  h-[280px]">
                                <div class="mr-4">
                                    <LazyImage src={item?.img} className={'mt-10 m-5 ms-0'} />
                                </div>
                                <div>
                                    <h3 class="text-lg font-medium">{item?.title}</h3>
                                    <p class="text-sm mt-1 opacity-[80%]">{item?.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default React.memo(Index)